import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  humanScribeStatus: [],
  humanScribeLoading: false,
  possibleStatus: [],
};

const humanScribeSlice = createSlice({
  name: 'humanScribeSlice',
  initialState,
  reducers: {
    humanScribeStatusSlice: (state, { payload }) => {
      state.humanScribeStatus = payload;
    },
    humanScribeLoadingSlice: (state, { payload }) => {
      state.humanScribeLoading = payload;
    },
    possibleStatusSlice: (state, { payload }) => {
      state.possibleStatus = payload;
    },
  },
});

const { actions, reducer } = humanScribeSlice;

export const {
  humanScribeStatusSlice,
  humanScribeLoadingSlice,
  possibleStatusSlice,
} = actions;

export default reducer;
